import { createSlice, createAsyncThunk, isAnyOf } from '@reduxjs/toolkit';
import api from '../api/axios';
import { login, logout, getMe, mfaVerified, ssoConsumeToken } from './authSlice';

export const fetchEntitlements = createAsyncThunk(
  'entitlements/fetchMine',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get('/api/entitlements/me');
      return data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'network_error');
    }
  }
);

const initialState = () => ({
  planTier: null,
  featureKeys: [],
  limits: {},
  available: false,
  loading: false,
  // Unlike the fields above, ai_assistant fails CLOSED (AI-D6): an
  // unresolved or failed lookup must never be read as "enabled".
  ai_assistant: false,
});

const entitlementsSlice = createSlice({
  name: 'entitlements',
  initialState: initialState(),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEntitlements.pending, (state) => { state.loading = true; })
      .addCase(fetchEntitlements.fulfilled, (state, action) => {
        state.loading = false;
        state.planTier = action.payload.planTier;
        state.featureKeys = action.payload.featureKeys || [];
        state.limits = action.payload.limits || {};
        state.available = action.payload.available !== false;
        state.ai_assistant = action.payload.ai_assistant === true;
      })
      .addCase(fetchEntitlements.rejected, (state) => {
        // Fails open by design (matches entitlementClient's own fail-open
        // contract) - a lookup failure must never read as "no plan".
        state.loading = false;
        state.available = false;
        state.ai_assistant = false;
      })
      .addMatcher(
        isAnyOf(login.fulfilled, logout.pending, logout.fulfilled, getMe.rejected, mfaVerified, ssoConsumeToken),
        () => initialState()
      );
  },
});

export default entitlementsSlice.reducer;
